import { ApiResponse, Client } from './typings';

export function isApiResponse(object: unknown): object is ApiResponse {
  return (
    Object.prototype.hasOwnProperty.call(object, 'success') &&
    Object.prototype.hasOwnProperty.call(object, 'message') &&
    Object.prototype.hasOwnProperty.call(object, 'error')
  );
}

export function isClient(object: unknown): object is Client {
  if (!object) return false;
  return (
    Object.prototype.hasOwnProperty.call(object, 'name') &&
    Object.prototype.hasOwnProperty.call(object, 'id')
  );
}
